import * as React from 'react';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';
import { IMatchHistory, IRecipient, IContact, IDonor, ICompatibilityResult, ILkdpiResults, IDonorPreselectNote, IBaseResponse, IListItem, ICrossMatchRejectionReason, IState as IStateItem, ISerologyTest, ISingleEpletMmRisk, IMatchOfferDeclineRootCause, IMatchOfferDeclineReasonListItem, IMatchOfferDeclineChoices } from '@nkr/models/index';
import { IApplicationState, AppActionCreators, DonorActionCreators, RecipientActionCreators, IMatchResponse, MatchActionCreators, CenterActionCreators, IMatchOfferAccept, IMatchOfferDecline, ICrossMatchAccept, ICrossMatchDecline, DonorPreselectActionCreators, FileActionCreators, IRequestExmResponse, IAppState, ICenterLegalDocumentsResponse, IAmbraDirectToViewerResponse } from '@nkr/store/index';
import { MatchHistoryType, CenterContactPosition, CenterAddressType, FileDocumentType, FileDocumentTypeDescription, InsuranceGroup, PatientType, DonationType, MortalityMatchType, MatchOfferDeclineReason, RecipientAction } from '@nkr/enums/index';
import { ICenterAddress } from '@nkr/models/center-address';
import Match from './match';
import { Alert, Badge, Button, ControlLabel, FormControl, Glyphicon } from 'react-bootstrap';
import { toast } from 'react-toastify';
import MatchOfferDecision from './modals/match-offer-decision';
import DeclineXMDecision from './modals/decline-xm-decision';
import CenterAddress from './modals/center-address';
import SerologyTests from './modals/serology-tests';
import TopButtons from './top-buttons';
import CenterAddresses from './center-addresses';
import { downloadFile } from '@nkr/services/download-file';
import RecipientNav from '../recipients/recipient-nav';
import { ContentWrapper } from './styles';
import { IMatchOfferDecisionReasonListResponse } from '@nkr/store/match';
import InfoRequest from './modals/info-request';
import ExmRequest from './modals/exm-request';
import HardBlock from './modals/hard-block';
import DecisionSavingWarning from './modals/decision-saving-warning';
import AcceptXMDecision, { IAcceptXMDecision } from './modals/accept-xm-decision';

interface IProps {
    recipientId: number,
    donorId: number,
    matchHistoryId: number,
    centerId: number,
    onUpdateRecipientAlias: (alias: string) => void
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getMatch: (matchHistoryId: number, centerId: number) => Promise<IMatchResponse>,
    updateDonorSurgeon: (donorId: number, contactId: number) => Promise<IBaseResponse>,
    updateRecipientSurgeon: (recipientId: number, contactId: number) => Promise<IBaseResponse>,
    updateCenterAddress: (id: number, centerId: number, typeId: number, addressLine1: string, addressLine2: string, addressLine3: string, city: string, state: number, postalCode: string, note: string, label: string) => Promise<IBaseResponse>,
    makeDecision: (matchHistoryId: number, centerId: number, initials: string, matchOfferAccept: IMatchOfferAccept, matchOfferDecline: IMatchOfferDecline, crossMatchAccept: ICrossMatchAccept, crossMatchDecline: ICrossMatchDecline, matchOfferDeclineHistory: IMatchOfferDeclineChoices) => Promise<IBaseResponse>,
    acceptDonor: (recipientId: number, donorId: number, isFullyConfident: boolean, hasMortalityRisk: boolean) => Promise<IBaseResponse>,
    declineDonor: (recipientId: number, recipientCenterId: number, donorId: number, hardBlockSource: string, declineReasons: { reasonId: number, otherText: string }[], isGlobalDecline: boolean, hasMortalityRisk: boolean) => Promise<IBaseResponse>,
    requestInfo: (recipientId: number, donorId: number, message: string) => Promise<IBaseResponse>,
    requestExm: (recipientId: number, donorId: number, message: string, allowDuplicate: boolean, freshBloodOverride: boolean) => Promise<IRequestExmResponse>,
    saveNotes: (recipientCenterId: number, donorId: number, recipientId: number, note: string) => Promise<IBaseResponse>,
    getFinancialAgreement: (centerId: number, donorId: number, recipientId: number) => Promise<any>,
    downloadFormsAndChecklist: (donorId: number, recipientId: number) => Promise<any>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    getAmbraLink: (donorId: number) => Promise<IAmbraDirectToViewerResponse>,
    getMatchOfferDeclineReasons: (matchHistoryId: number) => Promise<IMatchOfferDecisionReasonListResponse>,
    donorInMatch: (recipientId: number, donorId: number) => Promise<IBaseResponse>,
    getLegalDocuments: (centerId: number) => Promise<ICenterLegalDocumentsResponse>
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

interface IState {
    matchHistory: IMatchHistory,
    recipient: IRecipient,
    donor: IDonor,
    compatibilityResult: ICompatibilityResult,
    lkdpiResults: ILkdpiResults,
    compatiblePairLkdpiResults: ILkdpiResults,
    singleEpletMmRisk: ISingleEpletMmRisk,
    isRecipientCenter: boolean,
    isDonorCenter: boolean,
    donorNote: IDonorPreselectNote,
    donorNotesContent: string,
    matchNote: IDonorPreselectNote,
    matchNotesContent: string,
    donorKidneyPickupAddress: ICenterAddress,
    donorKidneyShipToAddress: ICenterAddress,
    recipientKidneyPickupAddress: ICenterAddress,
    recipientKidneyShipToAddress: ICenterAddress,
    serologyTestList: ISerologyTest[],
    pmp: string,
    currentDeclineRatio: number,
    newDeclineRatio: number,
    doesStudyExist: number,
    swapNumber: string,
    lookupData: {
        matchOfferDeclineRootCauseList: IMatchOfferDeclineRootCause[],
        matchOfferRejectionReasonList: IListItem[],
        crossMatchRejectionReasonList: ICrossMatchRejectionReason[],
        hardBlockReasons: IListItem[],
        stateList: IStateItem[],
        recipientCenterContactList: IContact[],
        donorCenterContactList: IContact[]
    },
    deadline: number,
    matchOfferDecision: {
        show: boolean,
        accept: boolean
    },
    crossMatchDecision: {
        show: boolean,
        accept: boolean
    },
    centerAddress: {
        show: boolean,
        data: ICenterAddress
    },
    declineDonor: {
        show: boolean,
        isGlobalDecline: boolean
    },
    requestExm: {
        show: boolean,
        freshBloodOverride: boolean
    },
    allowDuplicateXm: boolean,
    showInfoRequest: boolean,
    hasExistingXm: boolean,
    existingXmStatus: string,
    showSerologyTests: boolean,
    disableAcceptDeclineButtons: boolean,
    loading: boolean,
    declineReasonList: IMatchOfferDeclineReasonListItem[],
    isStreamlinedContract: boolean,
    showSavingWarning: boolean
}

class Evaluate extends React.Component<TProps, IState> {
    readonly state: IState = {
        matchHistory: null,
        recipient: null,
        donor: null,
        compatibilityResult: null,
        lkdpiResults: null,
        compatiblePairLkdpiResults: null,
        singleEpletMmRisk: null,
        isRecipientCenter: false,
        isDonorCenter: false,
        donorNote: null,
        donorNotesContent: '',
        matchNote: null,
        matchNotesContent: '',
        donorKidneyPickupAddress: null,
        donorKidneyShipToAddress: null,
        recipientKidneyPickupAddress: null,
        recipientKidneyShipToAddress: null,
        serologyTestList: [],
        pmp: '',
        currentDeclineRatio: 0,
        newDeclineRatio: 0,
        doesStudyExist: 0,
        swapNumber: '',
        lookupData: {
            matchOfferDeclineRootCauseList: [],
            matchOfferRejectionReasonList: [],
            crossMatchRejectionReasonList: [],
            hardBlockReasons: [],
            stateList: [],
            recipientCenterContactList: [],
            donorCenterContactList: []
        },
        deadline: 0,
        matchOfferDecision: {
            show: false,
            accept: false
        },
        crossMatchDecision: {
            show: false,
            accept: false
        },
        centerAddress: {
            show: false,
            data: null
        },
        declineDonor: {
            show: false,
            isGlobalDecline: false
        },
        requestExm: {
            show: false,
            freshBloodOverride: false
        },
        allowDuplicateXm: true,
        hasExistingXm: false,
        existingXmStatus: '',
        showInfoRequest: false,
        showSerologyTests: false,
        disableAcceptDeclineButtons: false,
        loading: true,
        declineReasonList: [],
        isStreamlinedContract: false,
        showSavingWarning: false
    }

    private _savingWarningTimer: ReturnType<typeof setTimeout> | null = null;

    useTimer: boolean = true;

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting match information, one moment please...').then(() => {

            this.props.getLegalDocuments(this.props.centerId).then(response => {
                if (response.data.success) {
                    let { isStreamlinedContract } = response.data.results;

                    this.setState({
                        isStreamlinedContract
                    });
                }
            });

            this.props.getMatchOfferDeclineReasons(this.props.matchHistoryId).then(response => {
                if (response.data.success) {
                    let declineReasonList = response.data.reasonList;

                    this.setState({
                        declineReasonList
                    });
                }
            });

            this.props.getMatch(this.props.matchHistoryId, this.props.centerId).then(response => {
                if (response.data.success) {
                    let {
                        matchHistory, recipient, donor, compatibilityResult, lkdpiResults, compatiblePairLkdpiResults,
                        singleEpletMmRisk,
                        isRecipientCenter, isDonorCenter,
                        donorNote, matchNote,
                        donorKidneyPickupAddress, donorKidneyShipToAddress,
                        recipientKidneyPickupAddress, recipientKidneyShipToAddress,
                        serologyTestList,
                        pmp,
                        currentDeclineRatio,
                        newDeclineRatio,
                        doesStudyExist,
                        swapNumber,
                        lookupData
                    } = response.data.results;

                    this.setState({
                        matchHistory,
                        recipient,
                        donor,
                        compatibilityResult,
                        lkdpiResults,
                        compatiblePairLkdpiResults,
                        singleEpletMmRisk,
                        isRecipientCenter,
                        isDonorCenter,
                        donorNote,
                        donorNotesContent: donorNote != null ? donorNote.note : '',
                        matchNote,
                        matchNotesContent: matchNote != null ? matchNote.note : '',
                        donorKidneyPickupAddress,
                        donorKidneyShipToAddress,
                        recipientKidneyPickupAddress,
                        recipientKidneyShipToAddress,
                        swapNumber,
                        serologyTestList,
                        pmp,
                        currentDeclineRatio,
                        newDeclineRatio,
                        doesStudyExist,
                        lookupData,
                        loading: false
                    }, () => {
                        this.props.hideLoading();

                        this.props.onUpdateRecipientAlias(this.state.recipient.alias);

                        setTimeout(() => {
                            this.updateCenterTime();
                        }, 1000);
                    });
                }
            });
        });
    }

    getOtherCenterId = () => {
        if (!this.state.isRecipientCenter && this.state.donor.position != 1)
            return this.state.recipient.centerId;

        if (this.state.isRecipientCenter && this.state.recipient.isInChip == false)
            return this.state.donor.centerId;

        return 0;
    }

    getDeadline = () => {
        if (this.state.matchHistory != null && this.state.matchHistory.decisionDateTime != '') {
            return <>--</>;
        }

        if (this.state.matchHistory != null && this.state.matchHistory.deadlineRemainingHours != null) {
            let hoursLeft = Math.round(this.state.matchHistory.deadlineRemainingHours);
            let backgroundColor = this.state.deadline == 0 ? '#808080' : '#DD0000';

            if (hoursLeft < 0) {
                return (
                    <>
                        <span style={{ backgroundColor, color: '#FFF', fontWeight: 'bold', padding: '2px 4px', borderRadius: 4 }}>
                            {this.state.matchHistory.deadlineDateTimeLocal}
                        </span>&nbsp;
                        <span style={{ backgroundColor, color: '#FFF', fontWeight: 'bold', padding: '2px 4px', borderRadius: 4 }}>
                            {Math.abs(hoursLeft)} hours LATE
                        </span>
                    </>
                );
            } else {
                return (
                    <>
                        <span style={{ backgroundColor: '#448822', color: '#FFFFFF', fontWeight: 'bold', padding: '2px 4px', borderRadius: 4 }}>
                            {this.state.matchHistory.deadlineDateTimeLocal}
                        </span>&nbsp;
                        <span style={{ backgroundColor: '#448822', color: '#FFFFFF', fontWeight: 'bold', padding: '2px 4px', borderRadius: 4 }}>
                            {hoursLeft} hours REMAINING
                        </span>
                    </>
                );
            }
        }

        return <span>[No deadline set]</span>;
    }

    updateCenterTime = () => {
        if (this.useTimer) {
            this.setState({
                deadline: this.state.deadline == 0 ? 1 : 0
            }, () => {
                setTimeout(() => {
                    this.updateCenterTime();
                }, 1000);
            });
        }
    }

    getWaitMessage = () => {        
        return 'One moment, please';
    }

    handleShowHideSerologyTests = () => {
        this.setState({
            showSerologyTests: !this.state.showSerologyTests
        });
    }

    handleUpdateRecipientSurgeon = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let contactId = parseInt(e.currentTarget.value);

        this.props.showLoading('Updating recipient surgeon, one moment please...').then(() => {
            this.props.updateRecipientSurgeon(this.state.recipient.id, contactId).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let recipient = _.cloneDeep(this.state.recipient)
                    let compatibilityResult = _.cloneDeep(this.state.compatibilityResult);

                    recipient.surgeonContactId = contactId;
                    compatibilityResult.recipient.surgeonContactId = contactId;

                    this.setState({
                        recipient,
                        compatibilityResult
                    }, () => {
                        toast.success('Recipient surgeon updated successfully');
                    });
                } else {
                    toast.error('Unable to update the recipient surgeon');
                }
            });
        });
    }

    handleFormsAndCheckLists = (donorId: number, recipientId: number) => {
        this.props.downloadFormsAndChecklist(donorId, recipientId)
            .then((response: any) => {
                downloadFile(response.data, `form-and-checklists-${recipientId}-${donorId}.pdf`, 'application/pdf');
            });
    }

    handleUpdateDonorSurgeon = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let contactId = parseInt(e.currentTarget.value);

        this.props.showLoading('Updating donor surgeon, one moment please...').then(() => {
            this.props.updateDonorSurgeon(this.state.donor.id, contactId).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let donor = _.cloneDeep(this.state.donor);
                    let compatibilityResult = _.cloneDeep(this.state.compatibilityResult);

                    donor.surgeonContactId = contactId;
                    compatibilityResult.donor.surgeonContactId = contactId;

                    this.setState({
                        donor,
                        compatibilityResult
                    }, () => {
                        toast.success('Donor surgeon updated successfully');
                    });
                } else {
                    toast.error('Unable to update the donor surgeon');
                }
            });
        });
    }

    handleEditCenterAddress = (address: ICenterAddress) => {
        this.useTimer = false;

        this.setState({
            centerAddress: {
                show: true,
                data: address
            }
        });
    }

    handleSaveCenterAddress = (addressLine1: string, addressLine2: string, addressLine3: string, city: string, state: number, postalCode: string, note: string, label: string) => {
        let { id, typeId } = this.state.centerAddress.data;

        this.setState({
            centerAddress: {
                show: false,
                data: null
            }
        }, () => {
            let message = typeId == CenterAddressType.KidneyPickup ? 'Updating center pickup address, one moment please...' : 'Updateing center delivery address, one moment please...';

            this.props.showLoading(message).then(() => {
                this.props.updateCenterAddress(id, this.props.centerId, typeId, addressLine1, addressLine2, addressLine3, city, state, postalCode, note, label).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        let stateItem = this.state.lookupData.stateList.find(x => x.id == state);

                        let donorKidneyPickupAddress = { ...this.state.donorKidneyPickupAddress };
                        let donorKidneyShipToAddress = { ...this.state.donorKidneyShipToAddress };

                        let recipientKidneyPickupAddress = { ...this.state.recipientKidneyPickupAddress };
                        let recipientKidneyShipToAddress = { ...this.state.recipientKidneyShipToAddress };

                        if (this.state.isDonorCenter) {
                            if (typeId == CenterAddressType.KidneyPickup) {
                                donorKidneyPickupAddress.addressLine1 = addressLine1;
                                donorKidneyPickupAddress.addressLine2 = addressLine2;
                                donorKidneyPickupAddress.addressLine3 = addressLine3;
                                donorKidneyPickupAddress.city = city;
                                donorKidneyPickupAddress.state = stateItem.description;
                                donorKidneyPickupAddress.stateAbbreviation = stateItem.abbreviation;
                                donorKidneyPickupAddress.postalCode = postalCode;
                            } else {
                                donorKidneyShipToAddress.addressLine1 = addressLine1;
                                donorKidneyShipToAddress.addressLine2 = addressLine2;
                                donorKidneyShipToAddress.addressLine3 = addressLine3;
                                donorKidneyShipToAddress.city = city;
                                donorKidneyShipToAddress.state = stateItem.description;
                                donorKidneyShipToAddress.stateAbbreviation = stateItem.abbreviation;
                                donorKidneyShipToAddress.postalCode = postalCode;
                            }
                        } else {
                            if (typeId == CenterAddressType.KidneyPickup) {
                                recipientKidneyPickupAddress.addressLine1 = addressLine1;
                                recipientKidneyPickupAddress.addressLine2 = addressLine2;
                                recipientKidneyPickupAddress.addressLine3 = addressLine3;
                                recipientKidneyPickupAddress.city = city;
                                recipientKidneyPickupAddress.state = stateItem.description;
                                recipientKidneyPickupAddress.stateAbbreviation = stateItem.abbreviation;
                                recipientKidneyPickupAddress.postalCode = postalCode;
                            } else {
                                recipientKidneyShipToAddress.addressLine1 = addressLine1;
                                recipientKidneyShipToAddress.addressLine2 = addressLine2;
                                recipientKidneyShipToAddress.addressLine3 = addressLine3;
                                recipientKidneyShipToAddress.city = city;
                                recipientKidneyShipToAddress.state = stateItem.description;
                                recipientKidneyShipToAddress.stateAbbreviation = stateItem.abbreviation;
                                recipientKidneyShipToAddress.postalCode = postalCode;
                            }
                        }

                        this.setState({
                            donorKidneyPickupAddress,
                            donorKidneyShipToAddress,
                            recipientKidneyPickupAddress,
                            recipientKidneyShipToAddress
                        }, () => {
                            toast.success(typeId == CenterAddressType.KidneyPickup ? 'Center pickup address updated successfully' : 'Center delivery address updated successfully');
                        });
                    } else {
                        toast.error(typeId == CenterAddressType.KidneyPickup ? 'Unable to update the center pickup address' : 'Unable to update the center delivery address');
                    }
                });
            });
        });
    }

    handleCancelCenterAddress = () => {
        this.useTimer = true;

        this.setState({
            centerAddress: {
                show: false,
                data: null
            }
        });
    }

    handleShowMatchDecision = (accept: boolean) => {
        this.useTimer = false;

        let donorId = this.state.donor.id;
        let recipientId = this.state.recipient.id;

        this.props.donorInMatch(donorId, recipientId).then(response => {
            this.props.hideLoading();

            if (response.data.success) {
                if (this.state.matchHistory.matchHistoryTypeId == MatchHistoryType.MatchOffer) {
                    this.setState({
                        matchOfferDecision: {
                            show: true,
                            accept
                        }
                    });
                } else {
                    this.setState({
                        crossMatchDecision: {
                            show: true,
                            accept
                        }
                    });
                }

            } else {
                toast.error(
                    'This Match Offer has been cancelled. No further action is needed. You may now close this page.',
                    {
                        autoClose: false,
                        closeOnClick: false,
                        draggable: false,
                    }
                );
            }

        });
    }

    startSavingWarning = () => {
        this._savingWarningTimer = setTimeout(() => {
            this.setState({ showSavingWarning: true });
        }, 0);
    }

    clearSavingWarning = () => {
        if (this._savingWarningTimer) {
            clearTimeout(this._savingWarningTimer);
            this._savingWarningTimer = null;
        }
        this.setState({ showSavingWarning: false });
    }

    handleSaveMatchOfferAccept = (isFullyConfident: boolean, whichKidney: string, lateReason: string, additionalComments: string, initials: string) => {
        this.setState({
            matchOfferDecision: { show: false, accept: false },
            disableAcceptDeclineButtons: true
        }, () => {
            let matchHistoryId = this.state.matchHistory.id;
            let centerId = this.props.centerId;
            let matchOfferAccept = { isFullyConfident, whichKidney, lateReason, additionalComments };

            this.startSavingWarning();
            this.props.makeDecision(matchHistoryId, centerId, initials, matchOfferAccept, null, null, null, null).then(response => {
                this.clearSavingWarning();

                if (response.data.success) {
                    toast.success('Match offer acceptance recorded successfully', {
                        onClose: () => {
                            window.location.href = '/center/' + this.props.centerId + '/action-center/pending-swaps';
                        }
                    });
                } else {
                    toast.error('Unable to record match offer acceptance');
                }
            }).catch(() => {
                this.clearSavingWarning();
                toast.error('Unable to record match offer acceptance');
            });
        });
    }

    handleSaveMatchOfferDecline = (blockFutureMatches: boolean, deactivatePair: boolean, rejectionReason: number, rejectionReasonText: string, additionalComments: string, initials: string, matchOfferDeclineHistory: IMatchOfferDeclineChoices) => {
        let { isSurgeryDateAcceptable, deactivatePatient, declineReasons } = matchOfferDeclineHistory;

        let matchOfferDecline: IMatchOfferDecline = { blockFutureMatches, deactivatePair, lateReason: null, rejectionReason, rejectionReasonText, rootCause: null, additionalComments, isSurgeryDateAcceptable, deactivatePatient, declineReasons };

        this.setState({
            matchOfferDecision: { show: false, accept: false },
            disableAcceptDeclineButtons: true
        }, () => {
            let matchHistoryId = this.state.matchHistory.id;
            let centerId = this.props.centerId;

            this.startSavingWarning();
            this.props.makeDecision(matchHistoryId, centerId, initials, null, matchOfferDecline, null, null, matchOfferDeclineHistory).then(response => {
                this.clearSavingWarning();

                if (response.data.success) {
                    toast.success('Match offer decline recorded successfully', {
                        onClose: () => {
                            window.location.href = '/center/' + this.props.centerId + '/action-center/pending-swaps';
                        }
                    });
                } else {
                    toast.error('Unable to record match offer decline');
                }
            }).catch(() => {
                this.clearSavingWarning();
                toast.error('Unable to record match offer decline');
            });
        });
    }

    handleSaveCrossMatchAccept = (initials: string, decision: IAcceptXMDecision) => {
        this.setState({
            crossMatchDecision: { show: false, accept: false },
            disableAcceptDeclineButtons: true
        }, () => {
            let matchHistoryId = this.state.matchHistory.id;
            let centerId = this.props.centerId;
            let crossMatchAccept: ICrossMatchAccept = { isDonorReviewedSatisfactorily: true, additionalComments: '', ...decision } as any;

            this.startSavingWarning();
            this.props.makeDecision(matchHistoryId, centerId, initials, null, null, crossMatchAccept, null, null).then(response => {
                this.clearSavingWarning();

                if (response.data.success) {
                    toast.success('Cross match acceptance recorded successfully', {
                        onClose: () => {
                            window.location.href = '/center/' + this.props.centerId + '/action-center/pending-swaps';
                        }
                    });
                } else {
                    toast.error('Unable to record cross match acceptance');
                }
            }).catch((error: any) => {
                this.clearSavingWarning();
                const errorMessage = error?.response?.data || error?.message || 'Unable to record cross match acceptance';
                toast.error(errorMessage, { autoClose: 10000 });
                this.setState({ disableAcceptDeclineButtons: false });
            });
        });
    }

    handleSaveCrossMatchDecline = (blockFutureMatches: boolean, deactivatePair: boolean, lateReason: string, rootCausePrimary: number, rootCauseSecondary: number, rejectionReasonText: string, measuresToTake: string, initials: string) => {
        this.setState({
            crossMatchDecision: { show: false, accept: false },
            disableAcceptDeclineButtons: true
        }, () => {
            let matchHistoryId = this.state.matchHistory.id;
            let centerId = this.props.centerId;
            let crossMatchDecline: ICrossMatchDecline = { blockFutureMatches, deactivatePair, lateReason, rootCausePrimary, rootCauseSecondary, rejectionReasonText, measuresToTake };

            this.startSavingWarning();
            this.props.makeDecision(matchHistoryId, centerId, initials, null, null, null, crossMatchDecline, null).then(response => {
                this.clearSavingWarning();

                if (response.data.success) {
                    toast.success('Cross match decline recorded successfully', {
                        onClose: () => {
                            window.location.href = '/center/' + this.props.centerId + '/action-center/pending-swaps';
                        }
                    });
                } else {
                    toast.error('Unable to record cross match declone');
                }
            }).catch(() => {
                this.clearSavingWarning();
                toast.error('Unable to record cross match decline');
            });
        });
    }

    handleCancelMatchDecision = () => {
        this.useTimer = true;

        if (this.state.matchHistory.matchHistoryTypeId == MatchHistoryType.MatchOffer) {
            this.setState({
                matchOfferDecision: { ...this.state.matchOfferDecision, show: false }
            }, () => {
                this.updateCenterTime();
            });
        } else {
            this.setState({
                crossMatchDecision: { ...this.state.crossMatchDecision, show: false }
            }, () => {
                this.updateCenterTime();
            });
        }
    }

    handleDonorNotesChange = (donorNotesContent: string) => {
        this.setState({
            donorNotesContent
        });
    }

    handleMatchNotesChange = (matchNotesContent: string) => {
        this.setState({
            matchNotesContent
        });
    }

    handleSaveNotes = (isMatch: boolean) => {
        let recipientCenterId = this.state.recipient.centerId;
        let donorId = this.state.donor.id;
        let recipientId = isMatch ? this.state.recipient.id : null;
        let notes = isMatch ? this.state.matchNotesContent : this.state.donorNotesContent;
        let loadingDescription = isMatch ? 'Saving match notes, one moment please...' : 'Saving donor notes, one moment please';
        let messagePrefix = isMatch ? 'Match notes ' : 'Donor notes ';

        this.props.showLoading(loadingDescription).then(() => {
            this.props.saveNotes(recipientCenterId, donorId, recipientId, notes)
                .then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success(messagePrefix + ' saved successfully');
                    }
                })
                .catch(error => {
                    toast.error('Unable to save ' + messagePrefix.toLowerCase());
                });
        });
    }

    handleGetFinancialInfo = () => {
        let { centerId } = this.props;
        let donorId = this.state.donor.id;
        let recipientId = this.state.recipient.id;

        this.props.showLoading('Getting financial info, one moment please...').then(() => {
            this.props.getFinancialAgreement(centerId, donorId, recipientId).then((response: any) => {
                this.props.hideLoading();

                downloadFile(response.data, `financial-info-${centerId}-${donorId}-${recipientId}.pdf`, 'application/pdf');
            });
        });
    }

    handleGetFile = (docType: FileDocumentType, donorId: number) => {
        this.props.downloadFile(docType, donorId).then((response: any) => {
            downloadFile(response.data, `${FileDocumentTypeDescription[docType]}.pdf`, response.headers.contentType)
        }).catch((error: IBaseResponse) => {
            toast.error("Unable to download file at this time.  Please contact support.");
        })
    }

    handleViewCtScan = (donorId: number) => {
        this.props.getAmbraLink(donorId).then(response => {
            window.open(response.data.results, "_blank");
        });
    }

    handleAcceptDonor = (isFullyConfident: boolean) => {
        let { recipientId, donorId } = this.props;
        let { hasMortalityRisk } = this.state.recipient;

        this.props.showLoading('Updating preselect, one moment please...').then(() => {
            this.props.acceptDonor(recipientId, donorId, isFullyConfident, hasMortalityRisk).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    toast.success('Preselect Completed successfully: Accepted ' + (isFullyConfident ? 'Fully Confident' : 'Not Fully Confident'));
                }
            });
        });
    }

    handleShowDeclineDonor = (isGlobalDecline: boolean) => {
        this.setState({
            declineDonor: {
                show: true,
                isGlobalDecline
            }
        });
    }

    handleDeclineDonor = (ids: number[], otherText: string) => {
        const otherTypes = [MatchOfferDeclineReason.DonorOther, MatchOfferDeclineReason.SurgeryDateOther, MatchOfferDeclineReason.PatientDeactivateOther] as number[];

        let { recipientId, donorId } = this.props;
        let { hasMortalityRisk } = this.state.recipient;
        let recipientCenterId = this.state.recipient.centerId;
        let isGlobalDecline = this.state.declineDonor.isGlobalDecline;

        let declineReasons = ids.map(x => {
            return { reasonId: x, otherText: otherText && otherTypes.includes(x) ? otherText : null }
        })

        this.setState({
            declineDonor: {
                show: false,
                isGlobalDecline: false
            }
        }, () => {
            this.props.showLoading('Updating preselect, one moment please...').then(() => {
                this.props.declineDonor(recipientId, recipientCenterId, donorId, 'Pre-Select', declineReasons, isGlobalDecline, hasMortalityRisk).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Preselect Completed successfully: Declined');
                    }
                });
            });
        });
    }

    handleCancelDeclineDonor = () => {
        this.setState({
            declineDonor: {
                show: false,
                isGlobalDecline: false
            }
        });
    }

    handleShowRequestInfo = () => {
        this.setState({
            showInfoRequest: true
        });
    }

    handleRequestInfo = (message: string) => {
        let { donor, recipient } = this.state;
        let donorId = donor.id;
        let recipientId = recipient.id;

        this.setState({
            showInfoRequest: false
        }, () => {
            this.props.showLoading('Sending info request, one moment please...').then(() => {
                this.props.requestInfo(recipientId, donorId, message).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Info request sent successfully');
                    }
                });
            });
        });
    }

    handleCancelRequestInfo = () => {
        this.setState({
            showInfoRequest: false
        });
    }

    handleShowRequestExploratoryXm = (freshBloodOverride: boolean) => {
        this.setState({
            requestExm: {
                show: true,
                freshBloodOverride
            }
        });
    }

    handleRequestExploratoryXm = () => {
        let { recipientId, donorId } = this.props;
        let allowDuplicateXm = this.state.allowDuplicateXm;
        let freshBloodOverride = this.state.requestExm.freshBloodOverride;

        this.setState({
            requestExm: {
                show: false,
                freshBloodOverride: false
            },
            allowDuplicateXm: false
        }, () => {
            this.props.showLoading('Sending exploratory XM request, one moment please...').then(() => {
                this.props.requestExm(recipientId, donorId, '', allowDuplicateXm, freshBloodOverride).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        let { xmId, orderNumber } = response.data.results;

                        let message = orderNumber != '' ? 'EXM request sent successfully (' + xmId + '): PathTec Order ' + orderNumber : 'EXM request sent successfully (' + xmId + ')';

                        toast.success(message);
                    } else {
                        toast.error("Unable to complete request: " + response.data.message);
                    }
                });
            });
        });
    }

    handleCancelRequestExploratoryXm = () => {
        this.setState({
            requestExm: {
                show: false,
                freshBloodOverride: false
            },
        });
    }

    render = () => {
        if (this.state.matchHistory == null)
            return <div style={{ padding: '0px 5px' }}>{this.getWaitMessage()}...</div>;

        const { matchHistory, isRecipientCenter, compatibilityResult, lookupData } = this.state;
        const { donor, recipient } = compatibilityResult;
        const { recipientCenterContactList, donorCenterContactList } = lookupData

        const isMatchOffer = matchHistory.matchHistoryTypeId == MatchHistoryType.MatchOffer;
        const btnTextAccept = isMatchOffer ? <div>ACCEPT<br />OFFER</div> : <div>DONOR CLEARED<br />&amp;<br />XM ACCEPTABLE</div>;
        const btnTextDecline = isMatchOffer ? <div>DECLINE<br />OFFER</div> : <div>DONOR DECLINED<br />OR<br />XM UNACCEPTABLE</div>;
        const btnSize = isMatchOffer ? 'lg' : 'lg';
        const recipientSurgeons = _.sortBy(recipientCenterContactList.filter(x => x.positions.filter(p => p.id == CenterContactPosition.KidneyRecipientSurgeon).length > 0), x => x.fullName);
        const donorSurgeons = _.sortBy(donorCenterContactList.filter(x => x.positions.filter(p => p.id == CenterContactPosition.KidneyDonorSurgeon).length > 0), x => x.fullName);
        const includeButtons = true;

        const centerIdToPrint = isRecipientCenter ? recipient.centerId : donor.centerId;
        const otherCenterId = this.getOtherCenterId();
        const reportDonorId = donor.id;
        const reportRecipientId = recipient.id;
        const isPastDeadline = matchHistory.deadlineRemainingHours != null ? matchHistory.deadlineRemainingHours < 0 : false
        const deadline = this.getDeadline();
        
        const isDirectDonationType = [PatientType.RemoteDirect, PatientType.KflInternalDirect, PatientType.NkrInternalDirect].includes(recipient.patientTypeId);
        const disableAcceptButton = isDirectDonationType && (!recipient.insurance.isInsuranceComplete || (recipient.insurance.primaryGroupId == InsuranceGroup.NoneSelected));

        const showCheckKidney = (donor.whichKidney == 'L-opt' || donor.whichKidney == 'R-opt') && donor.donationTypeId != DonationType.KflInternalDirect;

        return (
            <>
                <div style={{ padding: '0px 5px' }}>
                    <RecipientNav
                        activeKey='EVALUATE-MATCH'
                        isAdmin={false}
                        isNkrLogin={false}
                        centerId={this.props.centerId}
                        recipientId={this.state.recipient != null ? this.state.recipient.id : 0}
                        recipientAlias={this.state.recipient != null ? this.state.recipient.alias : ''}
                        matchHistoryId={this.props.matchHistoryId}
                    />

                    <ContentWrapper className='content-wrapper'>
                        <div className='container' style={{ marginTop: 20, marginBottom: 10 }}>
                            { disableAcceptButton && (
                                <Alert bsStyle='warning'><Glyphicon glyph='warning-sign' /> The financial info for recipient {recipient.alias} is missing.  <a href={`center/${recipient.centerId}/recipient/${recipient.id}/profile/fin-info`} target='_blank'>Click here</a> to go to the financial info tab of the recipient profile.</Alert>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                <div>
                                    <h2 style={{ margin: 0 }}>Evaluate Match</h2>
                                </div>
                                <div className='text-right'>
                                    <a href={`/center/${this.props.centerId}/action-center/pending-swaps`} className='btn btn-link'>Return to Swaps Page</a>
                                </div>
                            </div>
                        </div>

                        <TopButtons
                            isRecipientCenter={this.state.isRecipientCenter}
                            donorId={donor.id}
                            recipientId={recipient.id}
                            centerIdToPrint={centerIdToPrint}
                            otherCenterId={otherCenterId}
                            centerIdForContacts={this.state.isRecipientCenter ? this.state.donor.centerId : this.state.recipient.centerId}
                            reportDonorId={reportDonorId}
                            reportRecipientId={reportRecipientId}
                            centerId={this.props.centerId}
                            donor={this.state.donor}
                            onShowHideSerologyTests={this.handleShowHideSerologyTests}
                            onDownloadFormsAndChecklists={this.handleFormsAndCheckLists}
                        />

                        <div className='container' style={{ marginBottom: 20 }}>
                            <div style={{ display: 'flex' }}>
                                {this.state.isRecipientCenter ?
                                    <div style={{ width: 500 }}>
                                        <div className='row'>
                                            <ControlLabel className='col-xs-12 col-lg-5'>DEADLINE:</ControlLabel>
                                            <div className='col-xs-12 col-lg-7'>{deadline}</div>
                                        </div>

                                        <div className='row'>
                                            <ControlLabel className='col-xs-12 col-lg-5'>TARGET SURGERY DATE:</ControlLabel>
                                            <div className='col-xs-12 col-lg-7'>
                                                {moment(this.state.matchHistory.targetSurgeryDate).format('MM/DD/YYYY')}
                                            </div>
                                        </div>

                                        {(this.state.matchHistory.isAccepted == null || this.state.matchHistory.HasNoResponse) == true ?
                                            <div style={{ padding: '10px 0 0px 0' }}>
                                                <Button bsStyle='primary' bsSize={btnSize} style={{ marginRight: 10 }} disabled={this.state.disableAcceptDeclineButtons || disableAcceptButton} onClick={() => this.handleShowMatchDecision(true)}>
                                                    {btnTextAccept}
                                                </Button>

                                                <Button bsStyle='danger' bsSize={btnSize} disabled={this.state.disableAcceptDeclineButtons} onClick={() => this.handleShowMatchDecision(false)}>
                                                    {btnTextDecline}
                                                </Button>
                                            </div>
                                            :
                                            <div style={{ padding: '10px 0 0px 0' }}>
                                                <Button bsStyle='primary' bsSize='lg'>This offer has already<br />been evaluated</Button>
                                            </div>
                                        }
                                    </div>
                                    :
                                    <div style={{ width: 400 }}>
                                        <h4 className='heading'>No Action Required</h4>
                                    </div>
                                }

                                <div style={{ width: 650 }}>
                                    <div style={{ float: 'left', width: '33%' }}>
                                        {this.state.isRecipientCenter && (
                                            <div style={{ marginBottom: this.state.isRecipientCenter && this.state.isDonorCenter ? 10 : 0 }}>
                                                <ControlLabel htmlFor='RecipientSurgeon'>Recipient Surgeon</ControlLabel>
                                                <FormControl
                                                    componentClass='select'
                                                    value={recipient.surgeonContactId}
                                                    onChange={this.handleUpdateRecipientSurgeon}
                                                    style={{ width: '90%' }}
                                                >
                                                    <option value=''>Please Select</option>
                                                    {recipientSurgeons.map((contact, index) =>
                                                        <option value={contact.id}>{contact.fullName}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        )}

                                        {this.state.isDonorCenter && (
                                            <div>
                                                <ControlLabel htmlFor='DonorSurgeon'>Donor Surgeon</ControlLabel>
                                                <FormControl
                                                    componentClass='select'
                                                    value={donor.surgeonContactId}
                                                    onChange={this.handleUpdateDonorSurgeon}
                                                    style={{ width: '90%' }}
                                                >
                                                    <option value=''>Please Select</option>
                                                    {donorSurgeons.map((contact, index) =>
                                                        <option value={contact.id}>{contact.fullName}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        )}
                                    </div>

                                    <CenterAddresses
                                        isDonorCenter={this.state.isDonorCenter}
                                        rdnCenterId={this.state.donor.rdnCenterId}
                                        pickupCenterAlias={this.state.donor.rdnCenterId > 0 ? this.state.donor.rdnCenterAlias : this.state.donor.center.alias}
                                        pickupAddress={this.state.donorKidneyPickupAddress}
                                        shipToCenterAlias={this.state.recipient.center.alias}
                                        shipToAddress={this.state.recipientKidneyShipToAddress}
                                        kidneyPickupDateTime={this.state.donor.logistics.kidneyPickupDateTime}
                                        kidneyArrivalDateTime={this.state.donor.logistics.kidneyArrivalDateTime}
                                        onEditCenterAddress={this.handleEditCenterAddress}
                                    />
                                </div>
                            </div>
                        </div>

                        <Match
                            donor={this.state.donor}
                            recipient={this.state.recipient}
                            compatibilityResult={this.state.compatibilityResult}
                            lkdpiResults={this.state.lkdpiResults}
                            compatiblePairLkdpiResults={this.state.compatiblePairLkdpiResults}
                            singleEpletMmRisk={this.state.singleEpletMmRisk}
                            donorNote={this.state.donorNote}
                            donorNotesContent={this.state.donorNotesContent}
                            matchNote={this.state.matchNote}
                            matchNotesContent={this.state.matchNotesContent}
                            includeButtons={includeButtons}
                            doesStudyExist={this.state.doesStudyExist}
                            hasOutstandingOffer={false}
                            isRecipientCenter={this.state.isRecipientCenter}
                            showNotes={true}
                            isNkrLogin={this.props.app.user.group.isSuper}
                            swapNumber={this.state.swapNumber}
                            matchHistoryId={this.state.matchHistory.id}
                            onDonorNotesChange={this.handleDonorNotesChange}
                            onMatchNodesChange={this.handleMatchNotesChange}
                            onSaveNotes={this.handleSaveNotes}
                            onAcceptDonor={this.handleAcceptDonor}
                            onDeclineDonor={this.handleShowDeclineDonor}
                            onRequestInfo={this.handleShowRequestInfo}
                            onRequestExploratoryXm={this.handleShowRequestExploratoryXm}
                            onGetFile={this.handleGetFile}
                            onViewCtScan={this.handleViewCtScan}
                        />
                    </ContentWrapper>
                </div>

                <MatchOfferDecision
                    show={this.state.matchOfferDecision.show}
                    accept={this.state.matchOfferDecision.accept}
                    kidneyArrivalDateTime={donor.logistics.kidneyArrivalDateTime}
                    isThisAnAboTransplant={false}
                    isPastDeadline={isPastDeadline}
                    recipient={this.state.recipient}
                    donor={this.state.donor}
                    isClc={this.state.matchHistory.isClc}
                    isStreamlinedContract={this.state.isStreamlinedContract}
                    currentDeclineRatio={this.state.currentDeclineRatio}
                    newDeclineRatio={this.state.newDeclineRatio}
                    declineRootCauseList={this.state.lookupData.matchOfferDeclineRootCauseList}
                    rejectionReasonList={this.state.lookupData.matchOfferRejectionReasonList}
                    declineReasonList={this.state.declineReasonList}
                    showCheckKidney={showCheckKidney}
                    onSubmitAccept={this.handleSaveMatchOfferAccept}
                    onSubmitDecline={this.handleSaveMatchOfferDecline}
                    onCancel={this.handleCancelMatchDecision}
                />

                <DeclineXMDecision
                    show={this.state.crossMatchDecision.show && !this.state.crossMatchDecision.accept}
                    isPastDeadline={isPastDeadline}
                    crossMatchRejectionReasonList={this.state.lookupData.crossMatchRejectionReasonList}
                    onSubmitDecline={this.handleSaveCrossMatchDecline}
                    onCancel={this.handleCancelMatchDecision}
                />

                {/* BM-11545: the blood draw window keys off the donor's pickup date, because pickup is the donor's
                    surgery and this is the donor's draw. On a red-eye the stored MatchHistory target is the arrival
                    day instead, which puts the window a day out. Falls back to that target when pickup is not set. */}
                <AcceptXMDecision
                    show={this.state.crossMatchDecision.show && this.state.crossMatchDecision.accept}
                    targetSurgeryDate={this.state.donor?.logistics?.kidneyPickupDateTime || this.state.matchHistory?.targetSurgeryDate}
                    donorCenterId={this.state.donor?.centerId}
                    donorRdnCenterId={this.state.donor?.rdnCenterId}
                    recipientCenterId={this.state.recipient?.centerId}
                    onSubmitAccept={this.handleSaveCrossMatchAccept}
                    onCancel={this.handleCancelMatchDecision}
                />

                <CenterAddress
                    show={this.state.centerAddress.show}
                    centerAddress={this.state.centerAddress.data}
                    stateList={this.state.lookupData.stateList}
                    onSave={this.handleSaveCenterAddress}
                    onCancel={this.handleCancelCenterAddress}
                />

                <SerologyTests
                    show={this.state.showSerologyTests}
                    serologTestList={this.state.serologyTestList}
                    centerRequiresQfg={this.state.isDonorCenter ? donor.center.requiresQfg == 1 : recipient.center.requiresQfg == 1}
                    onClose={() => this.handleShowHideSerologyTests()}
                />

                <HardBlock
                    show={this.state.declineDonor.show}
                    alias={this.state.donor.alias}
                    centerAlias={this.state.donor.center.alias}
                    isGlobalDecline={this.state.declineDonor.isGlobalDecline}
                    warnOnHighDeclineRatio={this.state.recipient.warnOnHighDeclineRatio}
                    hasMortalityRisk={this.state.recipient.hasMortalityRisk}
                    mortalityRiskPercent={this.state.recipient.mortalityRiskPercent}
                    hardBlockReasons={this.state.lookupData.hardBlockReasons}
                    onDeclineDonor={this.handleDeclineDonor}
                    onCancel={this.handleCancelDeclineDonor}
                />

                <InfoRequest
                    show={this.state.showInfoRequest}
                    onConfirmRequest={this.handleRequestInfo}
                    onCancel={this.handleCancelRequestInfo}
                />

                <ExmRequest
                    show={this.state.requestExm.show}
                    hasExistingXm={this.state.hasExistingXm}
                    existingXmStaus={this.state.existingXmStatus}
                    onConfirmRequest={this.handleRequestExploratoryXm}
                    onCancel={this.handleCancelRequestExploratoryXm}
                />

                <DecisionSavingWarning show={this.state.showSavingWarning} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getMatch: (matchHistoryId, centerId) => {
            return dispatch(MatchActionCreators.getMatch(matchHistoryId, centerId));
        },
        updateDonorSurgeon: (donorId, contactId) => {
            return dispatch(DonorActionCreators.updateSurgeon(donorId, contactId));
        },
        updateRecipientSurgeon: (recipientId, contactId) => {
            return dispatch(RecipientActionCreators.updateSurgeon(recipientId, contactId));
        },
        updateCenterAddress: (id, centerId, typeId, addressLine1, addressLine2, addressLine3, city, state, postalCode, note, label) => {
            return dispatch(CenterActionCreators.updateCenterAddress({ id, centerId, typeId, addressLine1, addressLine2, addressLine3, city, stateId: state, postalCode, note, label, firstName: '', lastName: '', shipToPhoneNumber: '' }));
        },
        makeDecision: (matchHistoryId, centerId, initials, matchOfferAccept, matchOfferDecline, crossMatchAccept, crossMatchDecline, matchOfferDeclineHistory) => {
            return dispatch(MatchActionCreators.makeDecision(matchHistoryId, centerId, initials, matchOfferAccept, matchOfferDecline, crossMatchAccept, crossMatchDecline, matchOfferDeclineHistory));
        },
        acceptDonor: (recipientId, donorId, isFullyConfident, hasMortalityRisk) => {
            return dispatch(DonorPreselectActionCreators.acceptDonor(recipientId, donorId, isFullyConfident, hasMortalityRisk, MortalityMatchType.MatchOffer));
        },
        donorInMatch: (donorId, recipientId) => {
            return dispatch(MatchActionCreators.donorInMatch(donorId, recipientId));
        },
        declineDonor: (recipientId, recipientCenterId, donorId, hardBlockSource, hardBlockReasons, isGlobalDecline, hasMortalityRisk) => {
            return dispatch(DonorPreselectActionCreators.declineDonor(recipientId, recipientCenterId, donorId, hardBlockSource, hardBlockReasons, isGlobalDecline, hasMortalityRisk, MortalityMatchType.MatchOffer));
        },
        requestInfo: (recipientId, donorId, message) => {
            return dispatch(DonorPreselectActionCreators.requestInfo(recipientId, donorId, message));
        },
        requestExm: (recipientId, donorId, message, allowDuplicate, freshBloodOverride) => {
            return dispatch(DonorPreselectActionCreators.requestExm(recipientId, donorId, message, allowDuplicate, freshBloodOverride));
        },
        saveNotes: (recipientCenterId, donorId, recipientId, note) => {
            return dispatch(DonorPreselectActionCreators.saveNotes(recipientCenterId, donorId, recipientId, note));
        },
        getFinancialAgreement: (centerId, donorId, recipientId) => {
            return dispatch(FileActionCreators.getFinancialAgreement(centerId, donorId, recipientId));
        },
        downloadFormsAndChecklist: (donorId: number, recipientId: number) => {
            return dispatch(FileActionCreators.getFormsAndChecklists(donorId, recipientId));
        },
        downloadFile: (docType, id) => {
            return dispatch(FileActionCreators.downloadFile(docType, id))
        },
        getAmbraLink: (donorId) => {
            return dispatch(DonorActionCreators.getAmbraLink(donorId));
        },
        getMatchOfferDeclineReasons: (matchHistoryId) => {
            return dispatch(MatchActionCreators.getMatchOfferDeclineReasons(matchHistoryId))
        },
        getLegalDocuments: (centerId) => {
            return dispatch(CenterActionCreators.getLegalDocuments(centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(Evaluate)